module.exports = __webpack_public_path__ + "static/media/boat-img-40.0218569a.jpg";